import { isVisitorInChina } from './_utils';
import each from 'lodash/each';

const selectors = {
	pageFooterSocialLinks: '.PageFooter-social',
};

export default function chinaAdjustments() {
	if (isVisitorInChina()) {
		$(selectors.pageFooterSocialLinks).hide();

		const iframeElements = document.querySelectorAll('iframe');
		each(iframeElements, element => {
			const isYouTube = element.getAttribute('src').includes('youtube');
			if (isYouTube) {
				element.remove();
			}
		});
	}
}
